// extracted by mini-css-extract-plugin
export default {"barra_lateral":"icons_barra_lateral__dx7xz","imgs":"icons_imgs__K1bR0","imgs_logo":"icons_imgs_logo__exoLf","text":"icons_text__PEuM5","ativo":"icons_ativo__IlDUF"};